import CountdownTimer from "../../../../Props/CountdownTimer";

function AlarmRow({ title, startDate, status }) {
    const isActive = Number(status) === 1;

    return (
        <div className={`rectifier-alarm-row ${isActive ? "is-active" : "is-normal"}`}>
            <div className="rectifier-alarm-row__name">
                <span className={`rectifier-alarm-row__dot ${isActive ? "alarm" : "ok"}`} />
                <span className="rectifier-alarm-row__title">{title}</span>
            </div>
            <span className={`rectifier-alarm-row__status ${isActive ? "alarm" : "ok"}`}>
                {isActive ? "Critical" : "Normal"}
            </span>
            <span className="rectifier-alarm-row__time">{isActive ? startDate || "—" : "—"}</span>
            <span className="rectifier-alarm-row__elapsed">
                {isActive ? <CountdownTimer targetDate={startDate} /> : "00:00:00"}
            </span>
        </div>
    );
}

export default function RectifierAlarmPanel({ alarms, rectifier }) {
    const activeCount = alarms.filter((alarm) => Number(rectifier?.[alarm.status]) === 1).length;

    return (
        <div className="rectifier-alarm-panel">
            <div className={`rectifier-alarm-panel__summary ${activeCount ? "has-alarm" : ""}`}>
                <span className="rectifier-alarm-panel__count">{activeCount}</span>
                <span className="rectifier-alarm-panel__text">
                    Active alarm{activeCount === 1 ? "" : "s"}
                </span>
                <span className="rectifier-alarm-panel__divider">|</span>
                <span className="rectifier-alarm-panel__health">
                    {activeCount ? "Attention required" : "All normal"}
                </span>
            </div>

            <div className="rectifier-alarm-table">
                <div className="rectifier-alarm-table__head">
                    <span>Alarm</span>
                    <span>Status</span>
                    <span>Started</span>
                    <span>Elapsed</span>
                </div>
                <div className="rectifier-alarm-table__body">
                    {alarms.map((alarm) => (
                        <AlarmRow
                            key={alarm.title}
                            title={alarm.title}
                            startDate={rectifier?.[alarm.time]}
                            status={rectifier?.[alarm.status]}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
